export const getInventoryFileUploadInputs = (categories, initialValues) => [
  {
    type: "SELECT",
    label: "Category Id",
    id: "category_id",
    name: "category_id",
    value: initialValues?.category_id || "",
    options: categories,
    placeholder: "Select the Category ",
    validations: [
      {
        type: "REQUIRED",
        message: "Category is required !",
      },
    ],
  },
  {
    type: "FILE_UPLOAD",
    label: "Select File",
    id: "file",
    name: "file",
    placeholder: "Select File",
    value: null,
    validations: [
      { type: "REQUIRED",
        message: "File is required !" },
    ],
  }
  
  
];
